export function getLanguageName(code: string, availableLanguages: { code: string; name: string }[]): string {
  if (availableLanguages) {
    // Get the default value or the value for the current language
    let lang = availableLanguages.find((value) => {
      return value.code.toLowerCase() == code.toLowerCase();
    });
    // If not value, try to get the value for the language without the region
    if (!lang && code.length > 2) {
      lang = availableLanguages.find((value) => {
        return value.code.toLowerCase().startsWith(code.toLowerCase().substring(0, 2));
      });
    }
    return lang?.name || code;
  }
  return code;
}

export function getLanguageValue(
  value: any,
  language: string,
  languagesOrder: string[],
  readOnly: boolean,
): string | null {
  if (!value) {
    return null;
  }
  // Get the default value or the value for the current language
  let transtaledValue = getPlainValue(value, language);
  // If not value, try to get the value for the language without the region
  if (!transtaledValue && language.length > 2) {
    transtaledValue = value[language.substring(0, 2)];
  }
  // If still no value, try to get the value for the first available language
  if (!transtaledValue && readOnly) {
    transtaledValue = getLanguageHeuristic(value, languagesOrder);
  }
  return transtaledValue;
}

function getPlainValue(value, language): string | null {
  if (typeof value === 'string') {
    return value;
  }
  return value[language] || null;
}

function getLanguageHeuristic(value: any, languagesOrder: string[]): string | null {
  const foundLang = languagesOrder.find((lang) => value[lang] !== null && value[lang] !== undefined);
  return value[foundLang] || null;
}
